import React from "react";

import "./Sandbox.css";

export default function Sandbox() {
  return <div />;
}
